/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IVideoPlayerAdditionalContentViewProps } from '@msdyn365-commerce-modules/video-player/src/modules/video-player/./components/additional-content';
import { IVideoPlayerViewProps } from '@msdyn365-commerce-modules/video-player/src/modules/video-player/./video-player';

/**
 * Render Additional Content.
 * @param additionalContent - Additional content view props.
 * @returns JSX Element.
 */
const renderAdditionalContent = (additionalContent: IVideoPlayerAdditionalContentViewProps) => {
    if (additionalContent.additionalContentItems) {
        return (
            <Node {...additionalContent.additionalContentNode}>
                <>
                    {additionalContent.additionalContentItems.heading}
                    <Node {...additionalContent.additionalContentItems.additionalContentItemContainer}>
                        {additionalContent.additionalContentItems.text}
                        <Node {...additionalContent.additionalContentItems.additionalContentItemLinks}>
                            {additionalContent.additionalContentItems.links}
                        </Node>
                    </Node>
                </>
            </Node >
        );
    }

    return null;
};
const _isIPhone = () => {
    const useragent = window && window.navigator.userAgent;
    return !!useragent.match(/iphone/i);
}

const VideoPlayerView: React.FC<IVideoPlayerViewProps> = props => {
    const config = {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false
    };
    var observer = new MutationObserver(function (mutationRecords, observer) {
        const fullScreenBtn = document.querySelector(`#video-player .msc-videoplayer__controls__fullscreenbtn`) as HTMLElement;
        if(_isIPhone() && fullScreenBtn){
            const videoPlayer = document.querySelector(`#${props.id} video`);
            const fullScreenBtn = document.querySelector(`#video-player .msc-videoplayer__controls__fullscreenbtn`) as HTMLElement;
            function handleButtonClick(){
                // @ts-ignore
                videoPlayer && videoPlayer.webkitEnterFullscreen();
                //webkitRequestFullscreen
            }
            fullScreenBtn.addEventListener('click', handleButtonClick);
        }
    });
    React.useEffect(() => {
        const videoCtn = document && document.getElementById(`${props.id}`);
        console.log("videoCtn didMount");
        console.log(videoCtn);
        videoCtn !== null && observer.observe(videoCtn, config);
    },[]);

    return (
        <div
            id={props.id}
            className='ms-video-player'
            {...props.renderModuleAttributes(props)}
        >
            {props.player}
            <Node {...props.detailsContainer} className={props.detailsContainer ? props.detailsContainer.className : ''}>
                {props.title}
                {props.text}
                {props.additionalContent && renderAdditionalContent(props.additionalContent)}
                <Node {...props.detailsContainerCta} className={props.detailsContainerCta ? props.detailsContainerCta.className : ''}>
                    {props.links}
                </Node>
            </Node>
        </div>
    );
};

export default VideoPlayerView;
